import React from 'react'
import BottomSheetHint, {
  Dimming, SheetContainer,
} from '../../styles/bottomSheet'
import PairButtons from './PairButtons'

export default ({ children, submit, cancel, submitText, cancelText, loading, }) =>
  <BottomSheetHint>
    <Dimming onClick={cancel} />
    <SheetContainer>
      {children}
      {cancelText && submitText &&
        <PairButtons
          leftButton={{ text: cancelText, onClick: cancel, invert: true, }}
          rightButton={{ text: submitText, onClick: submit, loading, }}
        />
      }
    </SheetContainer>
  </BottomSheetHint>